import React, { useEffect, useState } from 'react';
import md5 from 'md5';
import {
  FaAngleDoubleDown,
  FaAngleDoubleUp,
  FaCartPlus,
  FaHeart,
  FaMapMarkerAlt,
  FaShare,
} from 'react-icons/fa';
import TOUR_LINK_KEYS from '../constants/OneTour';
import DEPART_DIC from '../constants/DepartDic';
import {
  beautyReefHotelList,
  noWindHotelList,
} from '../constants/EgypetCollectionHotelsList';
import formatNumber from '../utils/formatNumber';
import TouristGroupedByRoomTours from './TouristGroupedByRoomTours';
import FlightsClock from '../../../shared/components/FlightsClock';
import moment from 'moment';
import $ from 'jquery';
import _ from 'underscore';
import LoginForm from '../../../shared/lib/LoginForm';
import checkLikedOrAddedToCardTour from '../../../shared/lib/checkLikedOrAddedToCardTour';
import getDiscount from '../utils/getDiscount';
import { ShareModal } from '../components/ShareModal/ShareModal';
import {
  CURRENCY_CLASSES,
  CURRENCY_MAP_ICON,
  DEFAULT_CURRENCY_CLASS,
} from '../constants/CurrencyClasses';
import { TOUR_ROW_MAP } from '../constants/TourRowMap';
import { MEAL_TITLES } from '../constants/MealTitles';
import { BsFillLightningChargeFill, BsPeopleFill } from 'react-icons/bs';
import { MdFastfood, MdOutlineNightlight } from 'react-icons/md';
import { TbPlaneDeparture } from 'react-icons/tb';
import InExcludedDirections from '../utils/checkInExcludedDirections';
import OneTouristTour from './OneTouristTour';
import { IoWarning } from 'react-icons/io5';
import { Link } from 'react-router-dom';
import { AiFillLike, AiOutlineClose } from 'react-icons/ai';

const OneTouristHotelView = ({
  row,
  departure,
  request_model,
  recomend = false,
  discount,
  likes,
  carts,
  isAuth,
  tourData,
  onCartUpdate,
  onContinue,
  sort,
  onSort,
  getHotelInfo,
  hasGeograftourReviews,
}) => {
  const [isOpen, setOpen] = useState(false);
  const [isOpenModal, setOpenModal] = useState(false);
  const [geoKeyLikedTour, setGeoKeyLikedTour] = useState(null);
  const [geoKeyAddedToCartTour, setGeoKeyAddedToCartTour] = useState(null);
  const [isAuthSuccess, setIsAuthSuccess] = useState(isAuth);
  const [loginForm, setLoginForm] = useState(false);
  const [tourToShare, setTourToShare] = useState(null);
  const [roomList, setRoomList] = useState([]);
  const [groupedTours, setGroupedTours] = useState([]);
  const [toursLength, setToursLength] = useState(0);
  const [isHotelCardHidden, setHotelCardHidden] = useState(false);

  const toggleTours = () => {
    setOpen(!isOpen);
  };
  const handleContinue = (e) => {
    $(e.target).hide();
    onContinue();
  };

  const oneTour = (item) => {
    if (
      InExcludedDirections(
        item.operatorcode,
        item.departurecode,
        item.countrycode,
        item.regioncode
      )
    ) {
      return;
    }
    const depart_id = departure;
    const depart_name = DEPART_DIC[departure]?.name;
    const row = {
      provider: 'tourvisor',
      request_id: '',
      source_id: '',
      hash: '',
      currency_class: 'rouble',
      base_tour: 1,
      depart_id: depart_id,
      depart_name: depart_name,
    };
    _.each(item, function (value, key) {
      var new_key = TOUR_ROW_MAP[key] || key;
      row[new_key] = item[key] || '';
    });

    row.offer_id = item.tours.tour[0].tourid;
    row.place_id = item.tours.tour[0].placement;
    row.place_name = item.tours.tour[0].placement;
    row.room_id = item.tours.tour[0].room;
    row.room_name = item.tours.tour[0].room;
    row.oper_id = item.tours.tour[0].operatorcode;
    row.oper_name = item.tours.tour[0].operatorname;
    row.price = parseInt(item.price, 10);
    row.hot_price = 0;
    row.child = row.child == '' ? 0 : row.child;
    row.ages = '';
    if (parseInt(row.adult, 10) == 2 && parseInt(row.child, 10) == 0) {
      row.show_half = true;
      row.hot_price = Math.ceil(row.price / 2);
    }
    if (item.tours.tour[0].mealcode === 9067) {
      row.meal_full = 'По программе экскурсионного тура';
    } else {
      row.meal_full = MEAL_TITLES[item.tours.tour[0].meal] || '';
    }
    row.meal_id = item.tours.tour[0].mealcode;
    row.meal_name = item.tours.tour[0].meal;
    row.star_name = row.star_id + '*';
    row.dt1 = item.tours.tour.length
      ? item.tours.tour[0].flydate
      : '25.04.2024';
    row.nights = item.tours.tour[0].nights;
    row.dt2 = moment(row.dt1, 'DD.MM.YYYY')
      .add(parseInt(item.tours.tour[0].nights, 10), 'days')
      .format('DD.MM.YYYY');
    row.volatility = '';
    row.hotel_link = row.hotel_link;
    row.currency_class =
      CURRENCY_CLASSES[item.currency] || DEFAULT_CURRENCY_CLASS;

    row.adult = request_model['adults'];
    row.child = request_model['child'];
    row.ages = Array.isArray(request_model['ages'])
      ? request_model['ages'].join(',')
      : '';

    const discountParams = getDiscount(
      {
        depart: row.depart_id,
        country: row.country_id,
        oper: row.oper_id,
        region: row.town_id,
        subregion: row.subregion_id,
        hotel: row.hotel_id,
        adult: row.adult,
        child: row.child,
        meal: row.meal_id,
        dt: row.dt1,
        currency: row.currency,
      },
      discount
    );

    row.text = '';
    row.discount = false;

    if (discountParams && discountParams.active) {
      if (discountParams.currency_discount > 0) {
        row.price = row.price - discountParams.currency_discount;
      }
      row.text = discount.text;
      row.discount = true;
    }

    row.comment = ''; //FindTourComment(item);

    row.full_price = row.price;
    row.full_price_label = formatNumber(row.full_price);
    row.claim_mark = 'customer'; //(!!window.CLAIM_MARK) ? CLAIM_MARK : 'customer';
    row.credit = false;

    row.promo = /promo|промо/i.test(item.tours.tour[0].tourname) ? 1 : 0;
    if (row.claim_mark == 'small_credit') {
      row.credit = true;
    } else if (row.claim_mark == 'agency') {
    }
    row.hotel_adult = item.tours.tour[0].adults;
    row.hotel_child = item.tours.tour[0].child;

    return {
      row: row,
      tour_link: $.param(_.pick(row, TOUR_LINK_KEYS)),
      request_id: '',
      additional: '',
    };
  };

  const parseOneHotelTours = (item) => {
    const hotel = oneTour(item);
    return hotel;
  };

  const setTourLike = (data = tourData) => {
    if (isAuthSuccess || isAuth) {
      // тур не залайкан, отправляем данные и получаем geokey
      let like_data = data;
      let tour_hash = md5(like_data);
      like_data += `&like=true&tour_hash=${tour_hash}`;
      if (!geoKeyLikedTour) {
        $.ajax({
          url: 'https://cabinet.geograftour.com/orders/add-like-api/',
          data: like_data,
          dataType: 'jsonp',
          jsonp: 'callback',
          error: function (jqxhr) {
            console.log('Failed to load resource', jqxhr);
          },
          success: function (data) {
            if (data.geokey) {
              setGeoKeyLikedTour(data.geokey);
            }
            onCartUpdate();
          },
        });
      } else {
        // тур залайкан, значит есть geokey который отправим на удаление
        $.ajax({
          url: `https://cabinet.geograftour.com/orders/remove-json-tour/?geokey=${geoKeyLikedTour}`,
          dataType: 'jsonp',
          jsonp: 'callback',
          error: function (jqxhr) {
            setGeoKeyLikedTour(null);
            onCartUpdate();
          },
          success: function (data) {
            // обновить панель на форме
            setGeoKeyLikedTour(null);
            onCartUpdate();
          },
        });
      }
    } else {
      setLoginForm(true);
    }
  };

  const setTourToCart = (data = tourData) => {
    if (isAuthSuccess || isAuth) {
      let card_data = data;
      const tour_hash = md5(card_data);
      card_data += `&cart=true&tour_hash=${tour_hash}`;
      if (!geoKeyAddedToCartTour) {
        $.ajax({
          url: 'https://cabinet.geograftour.com/orders/add-cart-api/',
          data: card_data,
          dataType: 'jsonp',
          jsonp: 'callback',
          error: function (jqxhr) {
            console.log('Failed to load resource', jqxhr);
          },
          success: function (data) {
            if (data.geokey) {
              console.log('добавляем тур в корзину');
              setGeoKeyAddedToCartTour(data.geokey);
            }
            onCartUpdate();
          },
        });
      } else {
        $.ajax({
          url: `https://cabinet.geograftour.com/orders/remove-json-tour/?geokey=${geoKeyAddedToCartTour}&cart=true`,
          dataType: 'jsonp',
          jsonp: 'callback',
          error: function (jqxhr) {
            setGeoKeyAddedToCartTour(null);
            onCartUpdate();
          },
          success: function (data) {
            // обновить панель на форме
            setGeoKeyAddedToCartTour(null);
            onCartUpdate();
          },
        });
      }
    } else {
      setLoginForm(true);
    }
  };

  function handleOfficeSave() {
    localStorage.removeItem('officeId');
    if (window.location.pathname.includes('office')) {
      const { pathname } = window.location;
      const officeId = pathname
        .substring(pathname.indexOf('/office/') + '/office/'.length)
        .replace('/', '');
      localStorage.setItem('officeId', officeId);
    }
    // установить officeId со страницы отзыва на отель от определенного агента
    if (window.AGENT_OFFICE_ID) {
      localStorage.setItem('officeId', window.AGENT_OFFICE_ID);
    }
  }

  const handleSeen = () => {
    handleOfficeSave();
    let data = tourData;
    const tour_hash = md5(data);
    data += `&cart=false&like=false&tour_hash=${tour_hash}`;
    $.ajax({
      url: `https://cabinet.geograftour.com/orders/add-seen-api/`,
      data: data,
      dataType: 'jsonp',
      jsonp: 'callback',
      error: function (jqxhr) {
        console.log('Failed to load resource seen tour', jqxhr);
        onCartUpdate();
      },
      success: function (data) {
        // обновить панель на форме
        onCartUpdate();
      },
    });
  };

  const handleAuthSuccess = () => {
    // при успешной авторизации
    setIsAuthSuccess(true);
    onCartUpdate();
  };

  function groupToursByRoom(tourList) {
    if (tourList.length !== toursLength) {
      setToursLength(tourList.length);
      let roomList = [];
      tourList.forEach((tour) =>
        roomList.includes(tour.room) ? false : roomList.push(tour.room)
      );
      setRoomList(roomList);
      let group = {};
      for (let i = 0; i < tourList.length; i++) {
        let tour = tourList[i];

        if (group.hasOwnProperty(tour.room)) {
          group[tour.room].push(tour);
        } else {
          group[tour.room] = [tour];
        }
      }
      setGroupedTours(group);
    }
  }

  useEffect(() => {
    groupToursByRoom(row.tours.tour);
  }, [row.tours.tour]);

  useEffect(() => {
    const tourId = row.tours.tour[0].tourid;
    const LikedTour = checkLikedOrAddedToCardTour(tourId, likes);
    if (LikedTour) {
      setGeoKeyLikedTour(LikedTour);
    }
  }, [likes]);

  useEffect(() => {
    const tourId = row.tours.tour[0].tourid;
    const AddedToCartTour = checkLikedOrAddedToCardTour(tourId, carts);

    if (AddedToCartTour) {
      setGeoKeyAddedToCartTour(AddedToCartTour);
    }
  }, [carts]);

  function hideHotelCard() {
    setHotelCardHidden(!isHotelCardHidden);
  }

  const row_fix = parseOneHotelTours(row);

  return (
    <>
      {tourToShare ? (
        <ShareModal
          row={tourToShare}
          open={isOpenModal}
          handleClose={() => {
            setOpenModal(false);
            setTourToShare(null);
          }}
        />
      ) : null}
      {loginForm && (
        <LoginForm
          show={true}
          onAuth={() => handleAuthSuccess()}
          onClose={() => {
            setLoginForm(false);
          }}
        />
      )}
      <article
        className={`tour-card card-full ${
          isHotelCardHidden ? 'tour-card_hidden' : ''
        } ${recomend}`}
        data-tour-data={tourData}
      >
        <AiOutlineClose
          title="Скрыть данный отель"
          className="hotel-card__close-btn"
          onClick={hideHotelCard}
        ></AiOutlineClose>
        <section className="tour-card__image">
          <div className={'hotel-card__badges'}>
            {row_fix.row.promo ? (
              <div className="hotel-card__promo">ПРОМО</div>
            ) : null}
            {!!recomend ? (
              <div className="tour__geolike tour__badge">
                <AiFillLike title="Рекомендуем" />
              </div>
            ) : null}
          </div>
          <div
            title="Средний рейтинг отеля"
            className={`tour-card__raiting  rating--${parseInt(
              row.hotelrating
            )}`}
          >
            {parseFloat(row.hotelrating) > 0
              ? parseFloat(row.hotelrating).toFixed(1)
              : ''}
          </div>
          <img
            alt={row.hotelname}
            src={row_fix.row.hotel_image_src}
            className="tour-card__image-item"
            onClick={() => {
              handleSeen();
              getHotelInfo(row.hotelcode, 0);
            }}
            loading="lazy"
          />
          <div className="icon-bar">
            <div className="social-bar">
              <FaCartPlus
                className={`cart-${!!geoKeyAddedToCartTour} social-bar__icon`}
                onClick={setTourToCart}
                title="Добавить тур в корзину"
              />
              <FaHeart
                className={`like-${!!geoKeyLikedTour} social-bar__icon`}
                onClick={setTourLike}
                title="Добавить тур в избранное"
              />
              <FaShare
                title={'Поделиться туром'}
                className="share-icon"
                onClick={(e) => {
                  e.preventDefault();
                  setOpenModal(true);
                  setTourToShare(row_fix.row);
                }}
              />
              <FaMapMarkerAlt
                className="social-bar__icon"
                title="Отель на карте"
                onClick={() => {
                  handleSeen();
                  getHotelInfo(row.hotelcode, 1);
                }}
              />
              {!!hasGeograftourReviews ? (
                <div
                  className="tour__georeview"
                  onClick={() => {
                    handleSeen();
                    getHotelInfo(row.hotelcode, 2);
                  }}
                  title="Отзывы от Географии"
                >
                  <img
                    src="https://geograftour.com/static/index/img/geoclient/geo-simple-logo.webp"
                    alt=""
                    loading="lazy"
                  />
                </div>
              ) : null}
            </div>
          </div>
        </section>
        <section className="tour-card__body">
          <div className="tour-hotel__title title">
            <p className="hotelname" style={{ maxWidth: '90%' }}>
              {row_fix.row.star_id ? (
                <span className="hotelstars">{row_fix.row.star_id}*</span>
              ) : null}{' '}
              <b style={{ fontSize: '14px' }}>
                <span
                  className="clickable"
                  onClick={() => {
                    handleSeen();
                    getHotelInfo(row.hotelcode);
                  }}
                >
                  {row_fix.row.hotel_name}
                </span>
              </b>
            </p>
          </div>
          <div className="countryname">
            {row_fix.row.country_name}, {row_fix.row.town_name},
            {row_fix.row.seadistance && (
              <span>
                <small>
                  {' '}
                  <b>{row_fix.row.seadistance}</b>м до моря
                </small>
              </span>
            )}
          </div>
          <div className="tour-hotel__badge-feature">
            {row_fix.row.country_id == 1 &&
            beautyReefHotelList.includes(+row.hotelcode) ? (
              <span style={{ background: '#fc6464' }}>Красивый риф</span>
            ) : null}
            {row_fix.row.country_id == 1 &&
            noWindHotelList.includes(+row.hotelcode) ? (
              <span style={{ background: '#009abc' }}>Бухта без ветра</span>
            ) : null}
          </div>
          <section className="tour-card__info info">
            <section className="info__description">
              <div>
                <span style={{ color: 'cadetblue' }}>
                  <TbPlaneDeparture />
                </span>{' '}
                <b>
                  {DEPART_DIC[departure]?.id != 99 ? 'Из' : ''}{' '}
                  {DEPART_DIC[departure]?.name_from}{' '}
                  <FlightsClock tour_id={row.tours.tour[0].tourid} />
                </b>
              </div>
              <div>
                <span style={{ color: 'darkgoldenrod' }}>
                  <MdOutlineNightlight />
                </span>{' '}
                {moment(row_fix.row.dt1, 'DD.MM.YYYY').format('DD.MM')} -{' '}
                {moment(row_fix.row.dt2, 'DD.MM.YYYY').format('DD.MM')} (
                <b>{row_fix.row.nights} ночей</b>)
              </div>
              <div>
                <span>
                  <BsPeopleFill style={{ color: 'darkgreen' }} />{' '}
                  {row.tours.tour[0].placement}
                  {' | '}
                </span>
                <span>
                  <MdFastfood style={{ color: 'darkorange' }} />{' '}
                  {row_fix.row.meal_id === 9067
                    ? row_fix.row.meal_full
                    : `${row_fix.row.meal_name}, ${row_fix.row.meal_full}`}
                </span>
              </div>
              {row.hoteldescription.length ? (
                <div className="hotel-description">{row.hoteldescription}</div>
              ) : null}
            </section>
            <section className="info__price" style={{ position: 'relative' }}>
              <div className="tourname">{row.tours.tour[0].tourname}</div>
              {String(departure) !== '99' ? (
                <>
                  {row.tours.tour[0].regular === 1 ? (
                    <div className="tour-flight">
                      <IoWarning className="tour-flight__warning" />
                      <b>Рейс регулярный, возможны доплаты</b>
                    </div>
                  ) : (
                    <span className="charter">ЧАРТЕР</span>
                  )}
                  {row.tours.tour[0].fuelcharge ? (
                    <div className="tourname">
                      включен топливный сбор:{' '}
                      <b>
                        {row.tours.tour[0].fuelcharge}{' '}
                        {row.tours.tour[0].currency}
                      </b>
                    </div>
                  ) : null}
                </>
              ) : null}
              <Link
                to={`https://www.geograftour.com/tours/tour-info/${row.tours.tour[0].tourid}/`}
                onClick={handleSeen}
                className="btn__info"
                target="_blank"
              >
                <span className="price" id={row.hotelcode}>
                  {row_fix.row.full_price_label}
                  <small>{CURRENCY_MAP_ICON[row.tours.tour[0].currency]}</small>
                  <span>цена за тур</span>
                </span>
                {row.tours.tour[0].hotelstatus === 2 ? (
                  <span className="permanent-booking-container">
                    <BsFillLightningChargeFill
                      className="permanent-booking-icon"
                      title="Мгновенное бронирование"
                    />
                  </span>
                ) : null}
              </Link>
              <div onClick={toggleTours} className="toggle-tour">
                {isOpen ? <FaAngleDoubleUp /> : <FaAngleDoubleDown />} Все цены
                (<b>{row.tours.tour.length}</b>)
              </div>
            </section>
          </section>
        </section>
      </article>

      {isOpen ? (
        <>
          {row.tours.tour.length && sort === 'price' ? (
            <button
              className="tour__group-button"
              onClick={() => onSort('room')}
            >
              Группировать по типу номера
            </button>
          ) : (
            <button
              className="tour__group-button"
              onClick={() => onSort('price')}
            >
              Группировать по стоимости
            </button>
          )}
        </>
      ) : null}
      {isOpen && sort === 'room' ? (
        <TouristGroupedByRoomTours
          row_fix={row_fix}
          row={row}
          groupedTours={groupedTours}
          roomList={roomList}
          hideoperator={request_model.hideoperator}
          onContinue={handleContinue}
          likes={likes}
          carts={carts}
          request_model={request_model}
          setTourToShare={setTourToShare}
          setOpenModal={setOpenModal}
          setTourToCart={setTourToCart}
          setTourLike={setTourLike}
          handleOfficeSave={handleOfficeSave}
        />
      ) : (
        <>
          {isOpen && row.tours.tour.length && (
            <div className="hotel_hidden_list1" key={Date.now()}>
              {row.tours.tour.map((tour) => (
                <OneTouristTour
                  geoKeyLikedTour={geoKeyLikedTour}
                  geoKeyAddedToCartTour={geoKeyAddedToCartTour}
                  setTourToCart={setTourToCart}
                  setTourLike={setTourLike}
                  request_model={request_model}
                  departure={departure}
                  key={tour.tourid}
                  isAuth={isAuth}
                  onCartUpdate={onCartUpdate}
                  tourData={tourData}
                  likes={likes}
                  carts={carts}
                  row_fix={row_fix}
                  row={row}
                  hideoperator={request_model.hideoperator}
                  tour={tour}
                  setTourToShare={setTourToShare}
                  setOpenModal={setOpenModal}
                  handleOfficeSave={handleOfficeSave}
                />
              ))}
              {row.tours.tour.length > 3 ? (
                <div style={{ textAlign: 'center' }}>
                  <button
                    className="btn__search-tour-more"
                    style={{ padding: '5px 10px', fontSize: 12 }}
                    onClick={handleContinue}
                  >
                    еще туры
                  </button>{' '}
                </div>
              ) : null}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default OneTouristHotelView;
